module.exports = __webpack_public_path__ + "img/icon5.dafd089e.png";